export * from './matchHeaderOnScroll.types';
export { default as MatchHeaderOnScroll } from './matchHeaderOnScroll.component';
